// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after {
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
}

html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    font-size: 15px;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    background-color: var(--color-bg);
    color: var(--color-text);
    overscroll-behavior-y: none;
}

/* Default (Darcula) — also used when no data-theme is set */
:root {
    --color-bg: #232425;
    --color-bg-2: #2f3032;
    --color-bg-3: #393a3c;
    --color-border: #414245;
    --color-text: #bbbbbb;
    --color-text-muted: #808080;
    --color-accent: #2f65ca;
    --color-accent-hover: #4e80d9;
    --color-input-bg: #2f3032;
    --color-input-border: #414245;
    --color-input-border-focus: #2f65ca;
    --color-error: #f48771;
    /* Always-dark surface for TUI/process output so ANSI colors (designed
       for dark backgrounds) render correctly even under light themes. */
    --color-terminal-bg: #1b1c1d;
    --color-terminal-text: #bbbbbb;
}

:root[data-theme="darcula"] {
    --color-bg: #232425;
    --color-bg-2: #2f3032;
    --color-bg-3: #393a3c;
    --color-border: #414245;
    --color-text: #bbbbbb;
    --color-text-muted: #808080;
    --color-accent: #2f65ca;
    --color-accent-hover: #4e80d9;
    --color-input-bg: #2f3032;
    --color-input-border: #414245;
    --color-input-border-focus: #2f65ca;
    --color-error: #f48771;
    --color-terminal-bg: #1b1c1d;
    --color-terminal-text: #bbbbbb;
}

:root[data-theme="dark"] {
    --color-bg: #1e1e1e;
    --color-bg-2: #252526;
    --color-bg-3: #2d2d2d;
    --color-border: #3c3c3c;
    --color-text: #d4d4d4;
    --color-text-muted: #858585;
    --color-accent: #007acc;
    --color-accent-hover: #0098ff;
    --color-input-bg: #3c3c3c;
    --color-input-border: #3c3c3c;
    --color-input-border-focus: #007fd4;
    --color-error: #f14c4c;
    --color-terminal-bg: #181818;
    --color-terminal-text: #d4d4d4;
}

:root[data-theme="monokai"] {
    --color-bg: #272822;
    --color-bg-2: #2e2f2a;
    --color-bg-3: #3a3b35;
    --color-border: #3e3d32;
    --color-text: #f8f8f2;
    --color-text-muted: #75715e;
    --color-accent: #a6e22e;
    --color-accent-hover: #c8f050;
    --color-input-bg: #3e3d32;
    --color-input-border: #49483e;
    --color-input-border-focus: #a6e22e;
    --color-error: #f92672;
    --color-terminal-bg: #1e1f1a;
    --color-terminal-text: #f8f8f2;
}

:root[data-theme="dracula"] {
    --color-bg: #282a36;
    --color-bg-2: #21222c;
    --color-bg-3: #343746;
    --color-border: #44475a;
    --color-text: #f8f8f2;
    --color-text-muted: #6272a4;
    --color-accent: #bd93f9;
    --color-accent-hover: #cda8ff;
    --color-input-bg: #44475a;
    --color-input-border: #44475a;
    --color-input-border-focus: #bd93f9;
    --color-error: #ff5555;
    --color-terminal-bg: #1e1f29;
    --color-terminal-text: #f8f8f2;
}

:root[data-theme="light"] {
    --color-bg: #ffffff;
    --color-bg-2: #f3f3f3;
    --color-bg-3: #e8e8e8;
    --color-border: #d4d4d4;
    --color-text: #1e1e1e;
    --color-text-muted: #6e6e6e;
    --color-accent: #005fb8;
    --color-accent-hover: #0078d4;
    --color-input-bg: #ffffff;
    --color-input-border: #cecece;
    --color-input-border-focus: #005fb8;
    --color-error: #e51400;
    /* Light theme keeps a dark terminal surface on purpose. */
    --color-terminal-bg: #1e1e1e;
    --color-terminal-text: #d4d4d4;
}

ul, ol {
    list-style: none;
    margin: 0;
    padding: 0;
}

button {
    font-family: inherit;
    font-size: inherit;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
}

input {
    font-family: inherit;
    font-size: inherit;
}

a {
    color: var(--color-accent);
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

/* VSCode-style scrollbars */
::-webkit-scrollbar {
    width: 11px;
    height: 11px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 11px;
    border: 2px solid transparent;
    background-clip: content-box;
    min-height: 22px;
    min-width: 22px;
}

::-webkit-scrollbar-corner {
    background: transparent;
}

*:hover::-webkit-scrollbar-thumb {
    background-color: rgba(121, 121, 121, 0.4);
}

::-webkit-scrollbar-thumb:hover {
    background-color: rgba(121, 121, 121, 0.7) !important;
}

::-webkit-scrollbar-thumb:active {
    background-color: rgba(121, 121, 121, 0.9) !important;
}

* {
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
}

*:hover {
    scrollbar-color: rgba(121, 121, 121, 0.4) transparent;
}
`, "",{"version":3,"sources":["webpack://./styles/base.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gGAAgG;IAChG,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,iCAAiC;IACjC,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA,4DAA4D;AAC5D;IACI,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,mCAAmC;IACnC,sBAAsB;IACtB;wEACoE;IACpE,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,mCAAmC;IACnC,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,mCAAmC;IACnC,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,mCAAmC;IACnC,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,mCAAmC;IACnC,sBAAsB;IACtB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,mCAAmC;IACnC,sBAAsB;IACtB,0DAA0D;IAC1D,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,4BAA4B;AAC5B;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,qDAAqD;AACzD","sourcesContent":["*, *::before, *::after {\n    box-sizing: border-box;\n    -webkit-tap-highlight-color: transparent;\n}\n\nhtml, body {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    font-size: 15px;\n    font-weight: 400;\n    -webkit-font-smoothing: antialiased;\n    background-color: var(--color-bg);\n    color: var(--color-text);\n    overscroll-behavior-y: none;\n}\n\n/* Default (Darcula) — also used when no data-theme is set */\n:root {\n    --color-bg: #232425;\n    --color-bg-2: #2f3032;\n    --color-bg-3: #393a3c;\n    --color-border: #414245;\n    --color-text: #bbbbbb;\n    --color-text-muted: #808080;\n    --color-accent: #2f65ca;\n    --color-accent-hover: #4e80d9;\n    --color-input-bg: #2f3032;\n    --color-input-border: #414245;\n    --color-input-border-focus: #2f65ca;\n    --color-error: #f48771;\n    /* Always-dark surface for TUI/process output so ANSI colors (designed\n       for dark backgrounds) render correctly even under light themes. */\n    --color-terminal-bg: #1b1c1d;\n    --color-terminal-text: #bbbbbb;\n}\n\n:root[data-theme=\"darcula\"] {\n    --color-bg: #232425;\n    --color-bg-2: #2f3032;\n    --color-bg-3: #393a3c;\n    --color-border: #414245;\n    --color-text: #bbbbbb;\n    --color-text-muted: #808080;\n    --color-accent: #2f65ca;\n    --color-accent-hover: #4e80d9;\n    --color-input-bg: #2f3032;\n    --color-input-border: #414245;\n    --color-input-border-focus: #2f65ca;\n    --color-error: #f48771;\n    --color-terminal-bg: #1b1c1d;\n    --color-terminal-text: #bbbbbb;\n}\n\n:root[data-theme=\"dark\"] {\n    --color-bg: #1e1e1e;\n    --color-bg-2: #252526;\n    --color-bg-3: #2d2d2d;\n    --color-border: #3c3c3c;\n    --color-text: #d4d4d4;\n    --color-text-muted: #858585;\n    --color-accent: #007acc;\n    --color-accent-hover: #0098ff;\n    --color-input-bg: #3c3c3c;\n    --color-input-border: #3c3c3c;\n    --color-input-border-focus: #007fd4;\n    --color-error: #f14c4c;\n    --color-terminal-bg: #181818;\n    --color-terminal-text: #d4d4d4;\n}\n\n:root[data-theme=\"monokai\"] {\n    --color-bg: #272822;\n    --color-bg-2: #2e2f2a;\n    --color-bg-3: #3a3b35;\n    --color-border: #3e3d32;\n    --color-text: #f8f8f2;\n    --color-text-muted: #75715e;\n    --color-accent: #a6e22e;\n    --color-accent-hover: #c8f050;\n    --color-input-bg: #3e3d32;\n    --color-input-border: #49483e;\n    --color-input-border-focus: #a6e22e;\n    --color-error: #f92672;\n    --color-terminal-bg: #1e1f1a;\n    --color-terminal-text: #f8f8f2;\n}\n\n:root[data-theme=\"dracula\"] {\n    --color-bg: #282a36;\n    --color-bg-2: #21222c;\n    --color-bg-3: #343746;\n    --color-border: #44475a;\n    --color-text: #f8f8f2;\n    --color-text-muted: #6272a4;\n    --color-accent: #bd93f9;\n    --color-accent-hover: #cda8ff;\n    --color-input-bg: #44475a;\n    --color-input-border: #44475a;\n    --color-input-border-focus: #bd93f9;\n    --color-error: #ff5555;\n    --color-terminal-bg: #1e1f29;\n    --color-terminal-text: #f8f8f2;\n}\n\n:root[data-theme=\"light\"] {\n    --color-bg: #ffffff;\n    --color-bg-2: #f3f3f3;\n    --color-bg-3: #e8e8e8;\n    --color-border: #d4d4d4;\n    --color-text: #1e1e1e;\n    --color-text-muted: #6e6e6e;\n    --color-accent: #005fb8;\n    --color-accent-hover: #0078d4;\n    --color-input-bg: #ffffff;\n    --color-input-border: #cecece;\n    --color-input-border-focus: #005fb8;\n    --color-error: #e51400;\n    /* Light theme keeps a dark terminal surface on purpose. */\n    --color-terminal-bg: #1e1e1e;\n    --color-terminal-text: #d4d4d4;\n}\n\nul, ol {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\nbutton {\n    font-family: inherit;\n    font-size: inherit;\n    cursor: pointer;\n    border: none;\n    background: none;\n    padding: 0;\n}\n\ninput {\n    font-family: inherit;\n    font-size: inherit;\n}\n\na {\n    color: var(--color-accent);\n    text-decoration: none;\n}\n\na:hover {\n    text-decoration: underline;\n}\n\n/* VSCode-style scrollbars */\n::-webkit-scrollbar {\n    width: 11px;\n    height: 11px;\n}\n\n::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n    background-color: transparent;\n    border-radius: 11px;\n    border: 2px solid transparent;\n    background-clip: content-box;\n    min-height: 22px;\n    min-width: 22px;\n}\n\n::-webkit-scrollbar-corner {\n    background: transparent;\n}\n\n*:hover::-webkit-scrollbar-thumb {\n    background-color: rgba(121, 121, 121, 0.4);\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(121, 121, 121, 0.7) !important;\n}\n\n::-webkit-scrollbar-thumb:active {\n    background-color: rgba(121, 121, 121, 0.9) !important;\n}\n\n* {\n    scrollbar-width: thin;\n    scrollbar-color: transparent transparent;\n}\n\n*:hover {\n    scrollbar-color: rgba(121, 121, 121, 0.4) transparent;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
